import React from 'react';
import Icon from '../../../components/AppIcon';

const BudgetOverviewCards = ({ data }) => {
  const getUtilizationColor = (rate) => {
    if (rate >= 90) return 'text-error';
    if (rate >= 75) return 'text-warning';
    return 'text-success';
  };

  const getChangeColor = (changeType) => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    if (changeType === 'warning') return 'text-warning';
    return 'text-muted-foreground';
  };

  const getChangeIcon = (changeType) => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    if (changeType === 'warning') return 'AlertTriangle';
    return 'Minus';
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
      {data?.map((item) => (
        <div 
          key={item?.id}
          className="bg-card border border-border rounded-lg p-6 card-shadow hover:shadow-lg transition-smooth"
        >
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={item?.icon} size={20} className="text-primary" />
              </div>
              <h3 className="text-sm font-medium text-muted-foreground">{item?.title}</h3>
            </div>
            <Icon name="MoreVertical" size={16} className="text-muted-foreground cursor-pointer" />
          </div>

          <div className="space-y-4">
            {/* Main Value */}
            <div className="text-2xl font-bold text-foreground">{item?.value}</div>

            {/* Budget Breakdown */}
            {item?.allocated && (
              <div className="space-y-2">
                <div className="flex justify-between text-xs text-muted-foreground">
                  <span>Allocated: ${(item?.allocated / 1000000)?.toFixed(1)}M</span>
                  <span>Spent: ${(item?.spent / 1000000)?.toFixed(1)}M</span>
                </div>
                <div className="w-full bg-muted rounded-full h-2">
                  <div 
                    className={`h-2 rounded-full transition-all ${
                      item?.utilizationRate >= 90 ? 'bg-error' : 
                      item?.utilizationRate >= 75 ? 'bg-warning' : 'bg-success'
                    }`}
                    style={{ width: `${Math.min(item?.utilizationRate, 100)}%` }}
                  />
                </div>
                <div className="flex justify-between items-center text-xs">
                  <span className="text-muted-foreground">
                    Remaining: ${(item?.remaining / 1000000)?.toFixed(1)}M
                  </span>
                  <span className={`font-medium ${getUtilizationColor(item?.utilizationRate)}`}>
                    {item?.utilizationRate}%
                  </span>
                </div>
              </div>
            )}

            {/* Change Indicator */}
            {item?.change && (
              <div className={`flex items-center space-x-1 text-sm ${getChangeColor(item?.changeType)}`}>
                <Icon name={getChangeIcon(item?.changeType)} size={14} />
                <span>{item?.change}</span>
                <span className="text-muted-foreground">vs last period</span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BudgetOverviewCards;